import * as React from 'react';
import { sumComparisonGroup } from "./CTSAReportHelper";
import { Form } from "react-bootstrap";
import "./CompareGroupSelector.css";



const OPTIONS = ['K01', 'K08', 'K12', 'K23'];



const CompareGroupSelector = ({ onChange, selectedGroup, awardTotal, availableGroup }) => {
    return (
        <div>
            <div className="group-selector-container">
                <h4 className="group-selector-text"><span className="primary-text">Comparison Group Selection</span>:<br /><span className="sub-text">(Select as many groups as relevant)</span></h4>
                {
                    OPTIONS.map(group =>
                        <div>
                            <Form.Check type="checkbox" label={group} value={group} key={group} checked={selectedGroup.includes(group)} onChange={onChange} disabled={!availableGroup.includes(group)} />
                        </div>
                    )
                }

            </div>
            <p>You have selected {selectedGroup.length !== 0 ? selectedGroup.join(", ") : 0} scholars from your institution as a comparison group. There are {awardTotal ? sumComparisonGroup(awardTotal, selectedGroup) : <i className="fa fa-spinner"></i>} individuals in this group.</p>
        </div>
    )


}

export default CompareGroupSelector;